import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import storyJson from './library/storyJson';
import Front from './Front';


declare global {
    interface Window {
        getEnvironmentLink: Function;
    }
}

window.getEnvironmentLink = function getEnvironmentLink() {
    if(process.env.PUBLIC_URL.length) return process.env.PUBLIC_URL;
    if(process.env.REACT_APP_ENV === 'staging') return "https://editor-bundle-staging.storydoc.com"; //staging link
    if(process.env.REACT_APP_ENV === 'production') return "https://editor-bundle.storydoc.com"; //production link
    if(process.env.REACT_APP_ENV === 'dev') return "http://localhost:3000"; //production link
}

document.addEventListener('storydocRender', ((event: CustomEvent) => {

    // validations:
    if (!event.detail) throw new Error('Missing event.detail object');
    if (!event.detail.element) throw new Error('Missing event.detail.element as HTMLElement');

    const root = ReactDOM.createRoot(
        event.detail.element as HTMLElement
    );
    const storyData = event.detail.story ? event.detail.story : storyJson; // default to default json

    root.render(
        <Front originalData={storyData}/>
    );

}) as EventListener);

document.addEventListener('storydocReplaceCss', ((event: CustomEvent) => {
    if (!event.detail) throw new Error('Missing event.detail object');
    if (!event.detail.cssUrl) throw new Error('Missing event.detail.element as HTMLElement');
    const links = Array.from(document.querySelectorAll('link'));
    const layoutOldLink:any = links.find((link:any) => link.getAttribute('href').indexOf('layout-temp.css') > -1 || link.getAttribute('href').indexOf('layout-preview.css') > -1);
    if(layoutOldLink && layoutOldLink.getAttribute('href') === event.detail.cssUrl) return;
    if(layoutOldLink) layoutOldLink.remove();
    const layoutNewLink = document.createElement("link");
    layoutNewLink.href = event.detail.cssUrl + '?' + new Date().getTime();
    layoutNewLink.type = 'text/css';
    layoutNewLink.rel = 'stylesheet';
    document.head.append(layoutNewLink);
}) as EventListener);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
